<template>
    <modal ref="modal">
        <h3 slot="modal-title" v-if="issue">
            <i class="fas fa-comments"></i> {{resource('SprintPlanning_Comments_Comments_DisplayName')}} {{issue.issueId}}
        </h3>
        <div slot="modal-body" v-if="ready">

            <div class="row">
                <div class="col-12">
                    <div class="description-header">
                        <h4>{{resource('SprintPlanning_Comments_Description_DisplayName')}}</h4>
                    </div>
                    <div class="description" v-if="issue">
                        <p v-html="parseString(issue.description)">

                        </p>
                    </div>
                </div>
            </div>

            <div v-if="comments">
                <div class="row" v-for="comment in comments" :key="comment.id">
                    <div class="col-12">
                        <div class="comment-header">
                            <span class="author">{{comment.author.displayName}}</span> 
                            <span class="created">{{dateString(comment.created)}}</span>
                        </div>
                        <div class="comment-body">
                            <p v-html="parseString(comment.body)">

                            </p>
                        </div>
                    </div>
                </div>
            </div>


            <div class="row" v-if="canAddComments">
                <div class="col-12">
                    <div class="add-comment">
                        <add-comment ref="addComment"/>
                        <button class="btn btn-secondary pull-right mt-2" @click="addComment()">
                            <i class="fa fa-plus"></i> {{resource('Button_Add')}}
                        </button>
                    </div>
                </div>
            </div>

        </div>  
        <div slot="modal-footer">
            <button class="btn btn-secondary" @click="$refs.modal.hide()">
                <i class="fa fa-times"></i> {{resource('Button_Close')}}
            </button>
        </div>
    </modal>
</template>

<script>

//Util
import api from '../api';
import jira from '../Util/jira';
import {dateToString} from '../../../Util/time';
import {bootstrapDangerGrowl} from '../../../Util/growler';

//Mixins
import resourceMixin from '../../../Util/Mixins/resources';
import regexMixin from '../Mixins/regex';

//Components
import Modal from '../../../Components/Util/Modal.vue';
import Comment from './Comment.vue';

export default {
    name: 'sprint-planning-comments',
    mixins: [resourceMixin, regexMixin],
    components: {
        Modal,
        'add-comment': Comment
    },
    created() {
        const vm = this;
        
        api.validateCommentsWritePermission()
            .then(canWrite => vm.canAddComments = canWrite);
    },
    methods: {
        addComment() {
            const vm = this;
            const comment = vm.$refs.addComment.getValue();

            if(comment === '') {
                return;
            }

            const updateObj = jira.formUpdate( { comment: comment } );

            api.putIssue(vm.issue.issueId, updateObj).then(
                () => setTimeout(() => {
                    vm.load(vm.issue);
                    vm.$refs.addComment.setValue('');
                }, 1000), //Give jira a chance to save the comment
                bootstrapDangerGrowl
            );
        },
        load(issue) {
            const vm = this;
            vm.ready = false;
            vm.issue = issue;
            vm.description = vm.issue.description;

            api.getAttachments(vm.issue.issueId).then(
                (attachments) => {
                    vm.attachments = attachments;
                    vm.ready = true;
                    
                    api.getComments(vm.issue.issueId).then(
                        (comments) => {
                            vm.comments = comments;
                            vm.$refs.modal.show();
                        },
                        bootstrapDangerGrowl
                    );
                },
                (error) => {
                    bootstrapDangerGrowl(error);
                    vm.ready = true;
                }
            );
        },
        dateString(date) {
            return dateToString(date);
        }
    },
    data() {
        return {
            issue: null,
            comments: null,
            attachments: [],
            ready: false,
            
            canAddComments: false
        }
    },
    props: {
        users: {
            type: Array,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped src='../Style/comments.scss'>

</style>